module.exports = __webpack_public_path__ + "assets/img/8a993e0b1bca82b1b6dc7f1a45a60dff.svg";